import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Divider,
  Chip
} from '@mui/material'
import React, { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import EligibilityItemsTable from './EligibilityItemsTable'
import { getColor } from '../../../../PreAuth/components/response/ResponseDetailsComponentNew'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'

export function getDateDifferenceFormatted (dateRangeString) {
  if (dateRangeString) {
    const [startDateString, endDateString] = dateRangeString.split(' - ')
    const startDate = new Date(startDateString)
    const endDate = new Date(endDateString)

    const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
    const formattedStartDate = startDate.toLocaleDateString('en-GB', options)
    const formattedEndDate = endDate.toLocaleDateString('en-GB', options)

    return `${formattedStartDate} - ${formattedEndDate}`
  } else {
    return '___'
  }
}

function Coverages ({ items }) {
  const [expanded, setExpanded] = useState(null)
  return (
    <>
      <div className='eligibility_details_section'>
        <div className='eligibility_details_head'>
          {items?.map((item, index) => (
            <>
              <div className='border rounded-md '>
                <div className='eligibility_details_body_cont grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 p-2 m-0 !border-none mb-3 shadow-none'>
                  {/* Benefit Date */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Benefit Date
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {getDateDifferenceFormatted(item?.benefit_date)}
                      </span>
                    </div>
                  </div>

                  {/* Policy Holder */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Policy Holder
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.policy_holder || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Policy Number */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Policy Number
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.policy_number || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Member ID */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Member ID
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.member_id || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Type */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>Type</span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.type || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Status */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Status
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.status || '___'}
                      </span>
                    </div>
                  </div>

                  {/* In Force */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        In Force
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.in_force || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Relation with Subscriber */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Relation With Subscriber
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.relation_with_subscriber || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Network */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Network
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.network || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Class */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Class
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.class_value || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Class Type */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Class Type
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.class_group_type || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Class Plan */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Class Plan
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.class_plan_type || '___'}
                      </span>
                    </div>
                  </div>

                  {/* Copaypct */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Copaypct
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.cost_to_ben_copay_value || '0'}
                        {item?.cost_to_ben_copay_code || ''}
                      </span>
                    </div>
                  </div>

                  {/* Maxcopay */}
                  <div className='eligibility_details_user_data  px-1.5 py-1.5'>
                    <div className='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Maxcopay
                      </span>
                    </div>
                    <div className='data_cont !text-left'>
                      <span className='data_cont !text-base !text-[15px] !font-[600] !text-primary'>
                        {item?.cost_to_ben_max_copay_value || '0'}
                      </span>
                    </div>
                  </div>
                  <div className=' text-[14px] font-medium rounded-md min-w-[100px]'>
                    <span className='font-semibold text-black/70 text-base'>
                      Status
                    </span>
                    <div>
                      {item?.status ? (
                        <Chip
                          label={item?.status}
                          color={getColor(item?.status)}
                          size='small'
                          className='uppercase !text-white !text-base !text-[15px] !font-[600]'
                          style={{ color: 'white !important' }}
                        />
                      ) : (
                        '__'
                      )}
                    </div>
                  </div>
                </div>
                <div className='p-2'>
                  <Typography
                    className='flex gap-3 justify-between !w-[100%] !font-bold mb-2 !text-[18px]'
                    variant='h6'
                    sx={{ width: '50%', flexShrink: 0 }}
                  >
                    <span>Items</span>
                    <span
                      className='cursor-pointer transition-all duration-300 ease-in-out'
                      onClick={() =>
                        setExpanded(expanded === index ? null : index)
                      }
                    >
                      {expanded === index ? (
                        <RemoveIcon className='!w-[2rem] !h-[1.7rem]' />
                      ) : (
                        <AddIcon className='!w-[2rem] !h-[1.7rem]' />
                      )}
                    </span>
                  </Typography>
                  {expanded === index && (
                    <EligibilityItemsTable data={item?.items} />
                  )}
                </div>
              </div>
              <Divider className='my-4 !bg-primary !h-[5px]' />
            </>
          ))}
        </div>
      </div>
    </>
  )
}

export default Coverages
